function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from "vue-property-decorator";
var ModelPreview = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(ModelPreview, Vue1);
    var _super = _createSuper(ModelPreview);
    function ModelPreview() {
        _classCallCheck(this, ModelPreview);
        var _this;
        _this = _super.apply(this, arguments);
        _this.preivewURL = "/lmpreview/3d.html";
        return _this;
    }
    _createClass(ModelPreview, [
        {
            key: "iframeSrc",
            get: function get() {
                var url = this.preivewURL + "?lmUrl=" + this.lmUrl;
                if (this.texUrl) {
                    return url + "&texUrl=" + this.texUrl;
                }
                return url;
            }
        },
        {
            key: "builtInStyle",
            get: function get() {
                return {
                    width: this.width ? this.width + "px" : "100%",
                    height: this.height ? this.height + "px" : "100%"
                };
            }
        }
    ]);
    return ModelPreview;
}(Vue);
__decorate([
    Prop({
        type: String,
        required: true
    }) // lm 文件链接
], ModelPreview.prototype, "lmUrl", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    }) // 贴图路径，非必填
], ModelPreview.prototype, "texUrl", void 0);
__decorate([
    Prop({
        type: Number,
        required: false
    }) // width，非必填
], ModelPreview.prototype, "width", void 0);
__decorate([
    Prop({
        type: Number,
        required: false
    }) // height，非必填
], ModelPreview.prototype, "height", void 0);
ModelPreview = __decorate([
    Component
], ModelPreview);
export { ModelPreview as default };
